import { apiClient } from './client';

export interface ScrapeConfig {
  id?: number;
  platforms: string[];
  cron_schedule: string;
  detail_cron_schedule: string;
  max_listings_per_run: number;
  search_filters: Record<string, unknown> | null;
  is_active: boolean;
  last_run_at?: string | null;
  next_run_at?: string | null;
}

export interface ScrapeUrlItem {
  id?: number;
  url: string;
  label: string;
  platform: string;
  is_active: boolean;
}

/** Per-city scrape configuration. system_admin only. */
export const cityScrapeApi = {
  getZipcodes: async (cityId: number): Promise<string[]> => {
    const { data } = await apiClient.get(`/cities/${cityId}/zipcodes`);
    return data.zipcodes;
  },

  setZipcodes: async (cityId: number, zipcodes: string[]): Promise<void> => {
    await apiClient.put(`/cities/${cityId}/zipcodes`, { zipcodes });
  },

  getScrapeUrls: async (cityId: number): Promise<ScrapeUrlItem[]> => {
    const { data } = await apiClient.get(`/cities/${cityId}/scrape-urls`);
    return data;
  },

  setScrapeUrls: async (cityId: number, urls: ScrapeUrlItem[]): Promise<ScrapeUrlItem[]> => {
    const { data } = await apiClient.put(`/cities/${cityId}/scrape-urls`, { urls });
    return data;
  },

  getScrapeConfig: async (cityId: number): Promise<ScrapeConfig | null> => {
    const { data } = await apiClient.get(`/cities/${cityId}/scrape-config`);
    return data;
  },

  setScrapeConfig: async (
    cityId: number,
    config: Omit<ScrapeConfig, 'id' | 'last_run_at' | 'next_run_at'>,
  ): Promise<ScrapeConfig> => {
    const { data } = await apiClient.put(`/cities/${cityId}/scrape-config`, config);
    return data;
  },

  triggerScrape: async (cityId: number): Promise<void> => {
    await apiClient.post(`/cities/${cityId}/trigger-scrape`);
  },

  triggerMonitor: async (cityId: number): Promise<void> => {
    await apiClient.post(`/cities/${cityId}/trigger-monitor`);
  },
};
